import { render, staticRenderFns } from "./frenchp.vue?vue&type=template&id=9e867256&scoped=true&"
import script from "./frenchp.vue?vue&type=script&lang=js&"
export * from "./frenchp.vue?vue&type=script&lang=js&"
import style0 from "./frenchp.vue?vue&type=style&index=0&id=9e867256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e867256",
  null
  
)

export default component.exports